import { z } from 'zod'

import { GranularRateUnit, LiquidRateUnit, SeedingTank } from './ag-concepts'

/**
 * `rate` is in gal/ac; `displayUnit` is only the unit the operator reads it in.
 */
const liquidInputSchema = z.object({
  name: z.string(),
  rate: z.number(),
  displayUnit: z.enum(LiquidRateUnit)
})

/**
 * `rate` is in lbs/ac; `displayUnit` is only the unit the operator reads it in.
 */
const granularInputSchema = z.object({
  name: z.string(),
  rate: z.number(),
  displayUnit: z.enum(GranularRateUnit)
})

const carrierSchema = z.object({
  name: z.string(),
  displayUnit: z.enum(LiquidRateUnit)
})

const liquidMixDetailsSchema = z.object({
  name: z.string(),
  liquidInputs: z.array(liquidInputSchema),
  granularInputs: z.array(granularInputSchema)
})

/**
 * `targetRate` is the mix's total rate in gal/ac. The carrier makes up whatever that total leaves
 * after the liquid inputs, so it has no rate of its own.
 */
export const liquidMixSchema = z.union([
  liquidMixDetailsSchema.extend({
    carrier: carrierSchema,
    targetRate: z.number()
  }),
  liquidMixDetailsSchema.extend({
    carrier: z.undefined().optional()
  })
])

export const granularMixSchema = z.object({
  name: z.string(),
  granularInputs: z.array(granularInputSchema)
})

export const hybridSchema = z.object({
  name: z.string(),
  lotNumber: z.string().optional(),
  seedingTank: z.enum(SeedingTank).default(SeedingTank.Orange),
  treatments: z.array(z.object({ name: z.string() })),
  seedsPerUnit: z.number(),
  seedsPerPound: z.number().optional(),
  poundsPerUnit: z.number().optional()
})
